module.exports = __webpack_public_path__ + "static/media/modal-backing-9-slice.aca11a4a.png";